import { FETCH_SUGGESTIONS } from './constants'
import { call, put, select, takeLatest, apply } from 'redux-saga/effects'
import { fetchSuggestions } from './actions'
import languages from '../../constants/languages'
import { client as getClient, buildSuggestionQuery } from '../ESSearch/helpers'

function* fetchSuggestionsWorker(action) {
  let response = yield call(search, action.query)
  const results = response.aggregations.headings.buckets.map(item => item.key)
  yield put(fetchSuggestions.success(results))
}

function* search(query) {
  const state = yield select()
  const language = languages[state.devicebits.language]
  const customer = state.devicebits.customer

  // send first query without fuzziness
  const client = yield call(getClient, 'search-type-ahead')
  let results = yield apply(client, 'search', [
    {
      index: customer,
      body: buildSuggestionQuery(query, language)
    }
  ])

  if (results.aggregations.headings.buckets.length !== 0) {
    return results
  }

  // if no results were returned execute second query with fuzziness
  results = yield apply(client, 'search', [
    {
      index: customer,
      body: buildSuggestionQuery(query, language, { fuzziness: true })
    }
  ])

  return results
}

export default function* rootSaga() {
  yield takeLatest(FETCH_SUGGESTIONS.REQUEST, fetchSuggestionsWorker)
}



// WEBPACK FOOTER //
// ./src/containers/ESSearch/sagas.js